import React from 'react';
import { resetFreeSpin } from '../../redux/slices/freeSpinSlice';
import { resetPlaceBet } from '../../redux/slices/placeBetSlice';
import { useDispatch } from 'react-redux';
import { useGameSettings } from './slotData';

const FreeSpin = ({ freeSpinDetail, setFreeSpinDetail, setPlayFreeSpin, setFreeSpinAutoPlayCount, setSoundEffectFile }) => {

    const dispatch = useDispatch();
    const { bonusAudioUrl, featureWinAudioUrl, totalWinAudioUrl, normalButtonAudioUrl } = useGameSettings()

    const getImageElements = (value) => {
        return value
            .toString()
            .split('')
            .map((char, index) => (
                <img
                    key={index}
                    src={`/${char === '.' ? 'point' : char}.png`} // Replace `.` with `point.png`
                    alt={char}
                    className={`w-auto ${char === '.'
                        ? 'xs:h-4 sm:h-4 md:h-6 lg:h-10 xl:h-12 2xl:h-14 3xl:h-16 self-end'
                        : 'xs:h-10 sm:h-12 md:h-14 lg:h-24 xl:h-24 2xl:h-32 3xl:h-40'
                        }`}
                />
            ));
    };


    if (freeSpinDetail?.type === "WonFreeSpin") {
        setSoundEffectFile(bonusAudioUrl)
        return (
            <div
                className="w-full h-full bg-opacity-80 bg-[#12151D] flex items-center justify-center"
                style={{
                    backgroundImage: "url(/win-free-spin-bg.png)",
                    backgroundSize: "100% 100%",
                }}
            >
                <div className="flex flex-row"> {getImageElements(freeSpinDetail.spinLimit)}</div>
            </div>
        );
    }

    if (freeSpinDetail?.type === "FeatureFreeSpin") {
        setSoundEffectFile(featureWinAudioUrl)
        return (
            <div
                className="w-full h-full bg-opacity-80 bg-[#12151D] flex items-center justify-center"
                style={{
                    backgroundImage: "url(/feature-win-free-spin-bg.png)",
                    backgroundSize: "100% 100%",
                }}
            >
                <div className="flex flex-row"> {getImageElements(freeSpinDetail.featureWin.toFixed(2))}</div>
            </div>
        );
    }

    if (freeSpinDetail?.type === "TotalFreeSpin") {
        setSoundEffectFile(totalWinAudioUrl)
        return (
            <div
                className="w-full h-full bg-opacity-80 bg-[#12151D] flex items-center justify-center"
                style={{
                    backgroundImage: "url(/total-win-free-spin-bg.png)",
                    backgroundSize: "100% 100%",
                }}
            >
                <div className="flex flex-row"> {getImageElements(freeSpinDetail.totalProfit.toFixed(2))}</div>
                <div className='absolute bottom-0 h-[30%] w-full flex flex-col font-bold text-white xs:text-md md:text-xl lg:text-xl xl:text-2xl 2xl:text-3xl 3xl:text-5xl'>
                    <span>Game Win: {freeSpinDetail.gameWin.toFixed(2)}</span>
                    <span>Feature Win: {freeSpinDetail.featureWin.toFixed(2)}</span>
                    <div
                        className='w-full h-[70%] bg-center bg-no-repeat'
                        style={{
                            backgroundImage: "url(/continue-free-spin-bg.png)",
                            backgroundSize: "30% 120%",
                        }}
                        onClick={() => {
                            setSoundEffectFile(normalButtonAudioUrl)
                            setFreeSpinDetail({
                                type: "",
                                featureWin: 0,
                                totalProfit: 0,
                                gameWin: 0,
                                spinLimit: 0,
                                spinCount: 0,
                                showFreeSpin: false
                            })
                            setPlayFreeSpin(false)
                            dispatch(resetFreeSpin())
                            dispatch(resetPlaceBet())
                            setFreeSpinAutoPlayCount(0)
                        }}
                    ></div>
                </div>
            </div>
        );
    }

    if (freeSpinDetail?.type === "JackPotWin") {
        setSoundEffectFile(featureWinAudioUrl)
        return (
            <div
                className="w-full h-full bg-opacity-80 bg-[#12151D] flex items-center justify-center bg-center bg-no-repeat"
                style={{
                    backgroundImage: "url(/jackpot-win-bg.png)",
                    backgroundSize: "60% 65%",
                }}
            >
                <div className="flex flex-row"> {getImageElements(freeSpinDetail.jackPotWin.toFixed(2))}</div>
                <div className='absolute bottom-0 h-[30%] w-full flex flex-col font-bold text-white xs:text-md md:text-xl lg:text-xl xl:text-2xl 2xl:text-3xl 3xl:text-5xl'>
                    <div
                        className='w-full h-[70%] bg-center bg-no-repeat'
                        style={{
                            backgroundImage: "url(/continue-free-spin-bg.png)",
                            backgroundSize: "30% 120%",
                        }}
                        onClick={() => {
                            setSoundEffectFile(normalButtonAudioUrl)
                            dispatch(resetFreeSpin())
                            dispatch(resetPlaceBet())
                            setFreeSpinDetail({
                                type: "",
                                featureWin: 0,
                                totalProfit: 0,
                                gameWin: 0,
                                spinLimit: 0,
                                spinCount: 0,
                                showFreeSpin: false
                            })
                        }}
                    ></div>
                </div>
            </div>
        );
    }

    return null

}

export default FreeSpin;
